import type { Patient, Practitioner, Reference } from '@medplum/fhirtypes'
import { Role } from '@seen/core/roles'
import { useParticipantIdtMember } from '#src/hooks/useParticipantIdtMember.ts'

interface UseParticipantPcpResult {
  pcp: Reference<Practitioner> | undefined
  isPending: boolean
}

// Resolves a participant's PCP from their IDT care team. Returns the PCP
// reference (undefined while loading or when the IDT has no active PCP member)
// so callers can default an ordering provider to the authorizing clinician
// rather than whoever happens to be logged in.
export function useParticipantPcp(
  participant: Reference<Patient> | undefined
): UseParticipantPcpResult {
  const { member, isPending } = useParticipantIdtMember(participant, Role.PCP)
  return { pcp: member, isPending }
}
